import { Grid, OrbitControls } from "@react-three/drei";
import Lights from "../Lights.tsx";
import { MutableRefObject, useEffect, useRef } from "react";
import * as THREE from "three";
import Vector3 from "../WaveFunctionCollapseV2/Utils/Vector3.ts";
import { useControls } from "leva";
import { useThree } from "@react-three/fiber";
import EditorWorld from "./EditorWorld.tsx";

// Ground
const boxGeometry = new THREE.BoxGeometry(1, 1, 1);
const floorMaterial = new THREE.MeshStandardMaterial({
  color: "#ffffff",
});

const MAP_SIZE: Vector3 = new Vector3(10, 4, 10);

export default function EditorExperience() {
  const { camera } = useThree();

  // Debug controls
  const { cellSize } = useControls(
    {
      cellSize: 2,
    },
    [],
  );

  const orbitControlsRef: MutableRefObject<any> = useRef<any>(null);

  const center = new THREE.Vector3(
    (MAP_SIZE.x / 2) * cellSize - cellSize,
    0,
    (MAP_SIZE.z / 2) * cellSize - cellSize,
  );

  // Set the center of the camera and orbit controls to the center of the map
  useEffect(() => {
    const cameraOffset =
      Math.max(MAP_SIZE.x, MAP_SIZE.y, MAP_SIZE.z) * cellSize + 10;
    camera.position.set(
      center.x + cameraOffset,
      center.y + cameraOffset,
      center.z + cameraOffset,
    );
    orbitControlsRef.current.target = center;
  }, []);

  return (
    <>
      <OrbitControls makeDefault ref={orbitControlsRef} />
      <color args={["#ffffff"]} attach="background" />
      <Lights />
      <mesh
        geometry={boxGeometry}
        material={floorMaterial}
        position={center}
        scale={[
          MAP_SIZE.x * cellSize - 0.05, // - 0.05 to prevent z-fighting between grid and ground
          0.2,
          MAP_SIZE.z * cellSize - 0.05, // - 0.05 to prevent z-fighting between grid and ground
        ]}
        receiveShadow
      />
      <Grid
        args={[cellSize * 10, cellSize * 10]}
        cellSize={cellSize}
        cellThickness={2}
        cellColor={"#ffffff"}
        sectionSize={cellSize * 2}
        sectionThickness={3}
        sectionColor={"#969696"}
        infiniteGrid={true}
        fadeDistance={100}
        followCamera={true}
        position={[cellSize, 0.15, cellSize]} // Center the grid
      />

      <EditorWorld cellSize={cellSize} />
    </>
  );
}
